import { get, isEmpty, uniq } from 'lodash';

import ProfileCardType from 'models/configuration/profile_card_type';

export default class SendActiveAppCardAnalytics {
  constructor(context) {
    this.context = context;
  }

  run() {
    if (this._isLoading() || this._hasErrors()) return;

    // Find what apps are being used
    const entities = this.context.stores.externalAppCardTemplates.findAll();
    const enabledCardIDs = entities.filter(entity => isEmpty(entity.errors)).map(entity => entity.externalAppCardId);
    const profileDef = this.context.stores.customerProfileDef.get();
    const profileCards = profileDef?.profileCards || [];

    const appCards = profileCards.filter(card => card.type === ProfileCardType.EXTERNAL_APP_CARD);
    if (!appCards.length) return;

    const appNamespaces = enabledCardIDs.map(id => {
      const appCard = appCards.find(card => get(card, 'properties.cardParameters.externalAppCardId') === id);
      return get(appCard, 'properties.cardParameters.appNamespace');
    });
    const uniqueNamespaces = uniq(appNamespaces.filter(ns => !!ns)).sort();

    this.context.analytics.track('Active AppCard Configuration Loaded', {
      totalAppCards: appCards.length,
      enabledAppCards: enabledCardIDs.length,
      enabledAppNamespaces: uniqueNamespaces,
    });
  }

  _isLoading() {
    return (
      this.context.stores.externalAppCardTemplates.isLoading() || this.context.stores.customerProfileDef.isLoading()
    );
  }

  _hasErrors() {
    return (
      !isEmpty(this.context.stores.externalAppCardTemplates.getErrorForLoading()) ||
      !isEmpty(this.context.stores.customerProfileDef.getErrors())
    );
  }
}
